import { Controller } from "@hotwired/stimulus"

// Reorders the presentation rows on the admin session page by drag and drop
// and saves the new order with PATCH reorder_admin_session_path.
export default class extends Controller {
    static targets = ["list", "status", "orderNum"]
    static values = { url: String, savingMessage: String, savedMessage: String, failedMessage: String }

    connect() {
        this.dragged = null
        this.listTarget.addEventListener("dragstart", this.dragStart)
        this.listTarget.addEventListener("dragover", this.dragOver)
        this.listTarget.addEventListener("drop", this.drop)
        this.listTarget.addEventListener("dragend", this.dragEnd)
    }

    disconnect() {
        this.listTarget.removeEventListener("dragstart", this.dragStart)
        this.listTarget.removeEventListener("dragover", this.dragOver)
        this.listTarget.removeEventListener("drop", this.drop)
        this.listTarget.removeEventListener("dragend", this.dragEnd)
    }

    dragStart = (event) => {
        const row = event.target.closest("tr[draggable]")
        if (!row) return
        this.dragged = row
        this.originalOrder = this.currentIds()
        event.dataTransfer.effectAllowed = "move"
        event.dataTransfer.setData("text/plain", row.dataset.id)
        row.classList.add("opacity-50")
    }

    dragOver = (event) => {
        if (!this.dragged) return
        event.preventDefault()
        const row = event.target.closest("tr[draggable]")
        if (!row || row === this.dragged) return

        const rect = row.getBoundingClientRect()
        const after = event.clientY > rect.top + rect.height / 2
        row.parentNode.insertBefore(this.dragged, after ? row.nextSibling : row)
    }

    drop = (event) => {
        event.preventDefault()
    }

    dragEnd = () => {
        if (!this.dragged) return
        this.dragged.classList.remove("opacity-50")
        this.dragged = null

        const ids = this.currentIds()
        if (ids.join(",") !== this.originalOrder.join(",")) this.save(ids)
    }

    currentIds() {
        return Array.from(this.listTarget.querySelectorAll("tr[draggable]"), (row) => row.dataset.id)
    }

    async save(ids) {
        this.statusTarget.textContent = this.savingMessageValue
        const token = document.querySelector('meta[name="csrf-token"]')?.content

        try {
            const response = await fetch(this.urlValue, {
                method: "PATCH",
                headers: { "Content-Type": "application/json", "X-CSRF-Token": token },
                body: JSON.stringify({ presentation_ids: ids }),
            })
            if (!response.ok) throw new Error(response.statusText)

            this.listTarget.querySelectorAll("tr[draggable]").forEach((row, index) => {
                const cell = row.querySelector('[data-sortable-presentations-target="orderNum"]')
                if (cell) cell.textContent = index + 1
            })
            this.statusTarget.textContent = this.savedMessageValue
        } catch (error) {
            this.statusTarget.textContent = this.failedMessageValue
        }
    }
}
